import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { ProductiveHeading06 } from 'components/styles';

export const Label = styled.h6`
  ${ProductiveHeading06};

  color: var(--black-100);
  margin-bottom: var(--spacing-06);
`;

export const AlertButton = styled(Button)`
  background-color: transparent;
`;

export const Message = styled.div``;
